import { MealsService } from '@/backend/market'
import { LiveMealRepository } from '../../domain/repositories/LiveMealRepository'
import type { LiveMealFilterEntity } from '../../domain/entities/LiveMealFilterEntity'
import { LiveMealFilterModel } from '../models/LiveMealFilterModel'
import { LiveMealResponseModel } from '../models/LiveMealResponseModel'

export class LiveMealRepositoryImpl implements LiveMealRepository {
  async getLiveMeal(
    filterData: LiveMealFilterEntity
  ): Promise<LiveMealResponseModel | { error: true }> {
    const filterModel = new LiveMealFilterModel(filterData)
    try {
      const response = await MealsService.getMealStreamsAdmin(filterModel)
      const liveMealResponseModel = new LiveMealResponseModel(response)

      return liveMealResponseModel
    } catch {
      return { error: true }
    }
  }
  async watchMeal(mealId: string): Promise<{ success: true } | { error: true }> {
    try {
      await MealsService.postMealTrackingAdmin({ id: mealId })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
